import React from 'react';
import { useSelector } from 'react-redux';
import { RiskScore, StyledLinkButton } from '../../RiskToleranceStyles';
import { Card } from '../../../../CommonComponents/OPL/Card/Card';
import { Text } from '../../../../CommonComponents/OPL/Text/Text';
import { selectRiskScore } from '../../RiskToleranceSelector';
import {
  selectCanDoRiskQuestionnaire,
  selectIsHiddenLeversRTQ,
} from '../../../../CommonSelectors/CommonAreaSelector';

interface OrionResultProps {
  onRetakeAssessment(): void;
}

const RiskScoreContent = ({ onRetakeAssessment }: OrionResultProps) => {
  const riskScore = useSelector(selectRiskScore);
  const isHiddenLeversRTQ = useSelector(selectIsHiddenLeversRTQ);
  const canDoRiskQuestionnaire = useSelector(selectCanDoRiskQuestionnaire);

  if (!canDoRiskQuestionnaire && riskScore) {
    return (
      <div>
        Your Risk Score <RiskScore>{riskScore}</RiskScore>
      </div>
    );
  }

  if (!riskScore) {
    return (
      <StyledLinkButton onClick={onRetakeAssessment}>
        Assess My {isHiddenLeversRTQ ? 'Risk Profile' : 'Risk Tolerance'}
      </StyledLinkButton>
    );
  }

  return (
    <>
      <div>
        Your Risk Score <RiskScore>{riskScore}</RiskScore>
      </div>

      <StyledLinkButton onClick={onRetakeAssessment}>Retake my assessment</StyledLinkButton>
    </>
  );
};

export const OrionResult = ({ onRetakeAssessment }: OrionResultProps) => {
  const riskScore = useSelector(selectRiskScore);
  const isHiddenLeversRTQ = useSelector(selectIsHiddenLeversRTQ);
  const canDoRiskQuestionnaire = useSelector(selectCanDoRiskQuestionnaire);

  if (!canDoRiskQuestionnaire && !riskScore) {
    return null;
  }

  return (
    <>
      <Text mb="16" fontSize="h6">
        Determine your {isHiddenLeversRTQ ? 'risk profile' : 'risk tolerance'}
      </Text>

      <Card
        display="flex"
        alignItems="center"
        justifyContent={riskScore ? 'space-between' : 'center'}
        p="24"
      >
        <RiskScoreContent onRetakeAssessment={onRetakeAssessment} />
      </Card>
    </>
  );
};
